<!--
 * @message: 列表顶部筛选组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-03-29 10:08:21
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_List_Selections\Top_Selection.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-09 14:28:32
-->
<template>
  <div class="d-flex flex-row justify-end" :class="contentClass">
    <v-container fluid class="ma-0 pa-0 d-flex flex-column" v-if="false">
      <!-- 不显示第一个了 julia -->
      <v-form lazy-validation ref="form">
        <v-row align="center">
          <v-col
            :cols="item.Options && item.Options.cols ? item.Options.cols : 12"
            :lg="item.Options && item.Options.lg ? item.Options.lg : 4"
            :xl="item.Options && item.Options.lg ? item.Options.xl : 3"
            :xs="item.Options && item.Options.xs ? item.Options.xs : 12"
            :md="item.Options && item.Options.md ? item.Options.md : 4"
            :sm="item.Options && item.Options.sm ? item.Options.sm : 6"
            v-show="item.position == 'top'"
            v-for="(item, index) in ObjectsCopy"
            :key="`filters---${index}`"
          >
            <slot
              :item="item"
              :index="index"
              :name="item.name"
              :show-label="showLabel"
            />
          </v-col> </v-row
      ></v-form>
      <v-sheet color="transparent pt-3" v-if="showChip">
        <template v-for="(item, index) in filteredChips">
          <v-hover :key="`fliterChip---${index}`">
            <template v-slot:default="{ hover }">
              <v-chip
                class="mx-1 px-2"
                :close="hover || forceClose ? true : false"
                color="grey lighten-2 "
                @click:close="$emit('closeOne', item['name'], '')"
              >
                <div
                  class="d-inline-block text-truncate"
                  :style="getStyle(item['type'])"
                  :title="item.value"
                >
                  {{ $t(item.label) }}:{{ getSelectedValue(item, item.value) }}
                </div>
              </v-chip>
            </template>
          </v-hover>
        </template>
      </v-sheet>
    </v-container>
    <!-- <v-spacer></v-spacer> -->
    <v-sheet
      class="d-flex flex-row align-center fill-height"
      :class="showLabel ? 'justify-end ' : 'justify-space-around'"
      color="transparent"
    >
      <v-sheet class="d-flex flex-row align-center" color="transparent">
        <v-btn
          icon
          v-if="!canApply && false"
          depressed
          class="mx-2 grey lighten-3"
          color="grey "
          width="40"
          height="40"
          @click="$emit('close')"
        >
          <span class="material-icons-round"> expand_less </span>
        </v-btn>
        <v-btn
          text
          v-if="canApply && false"
          depressed
          rounded
          icon
          :disabled="status == 1"
          width="40"
          height="40"
          class="mx-2 text-capitalize"
          color="primary "
          @click="onSubmit"
        >
          <span class="material-icons-round"> search </span>
          <!-- <span>{{ $t("label_essweb_system_list_filter_applyBtnLabel") }}</span> -->
        </v-btn>

        <v-btn
          v-if="hasRight"
          outlined
          depressed
          class="mx-2 px-2"
          color="primary"
          @click="showMore = true"
        >
          <span class="pr-2">
            {{
              $t("message_essweb_system_list_filter_AdvancedFilterTip")
            }}</span
          >
          <v-badge dot overlap color="red" v-model="right_canApply">
            <span class="material-icons-round"> tune </span>
          </v-badge>
        </v-btn>
      </v-sheet>
    </v-sheet>
    <RightSelection
      :show="showMore"
      @close="showMore = false"
      @submit="onSubmit"
      @onChange="controlNav"
      :objects="objects"
      :key="curKey"
      @clear="
        reset();
        showMore = false;
      "
    >
      <template
        :slot="it.name"
        slot-scope="{ item, index }"
        v-for="(it, ind) in ObjectsCopy"
      >
        <v-sheet :key="`filters2---${ind}`">
          <slot :item="item" :index="index" :name="it.name">
            <FilterInputField
              :object="item"
              :small-chip="smallChip"
              @change="
                (prop, value, selected) => {
                  $emit('update', prop, value, selected);
                }
              "
              :index="index"
            >
            </FilterInputField>
          </slot>
        </v-sheet>
      </template>
    </RightSelection>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import RightSelection from "@/components/MRC_ESS_List_Selections/Right_Selection";
export default {
  name: "Top_Selection",
  components: { RightSelection },
  props: {
    objects: { default: [], type: [Array, Object] },
    forceClose: { default: false, type: Boolean }, //强制显示关闭按钮
    showChip: { default: false, type: Boolean }, //显示筛选条件chip
    smallChip: { default: true, type: [Boolean, Number] }, //小chips
    show: { default: true, type: Boolean },
    showLabel: { default: true, type: Boolean },
    contentClass: { default: "  ", type: String },
  },
  watch: {
    objects(val) {
      // console.log(val);
    },
    filteredChips(val, old) {
      this.status = 0; //切换回没有提交状态
      if (old.length > 0 && val.length <= 0 && this.isApply && !this.showMore) {
        this.reset();
      }
    },
    showMore(val) {
      if (!val && this.filteredChips.length <= 0 && this.isApply) {
        this.reset();
      }
    },
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    hasRight() {
      let has = false;
      this.objects.some((item) => {
        if (item.position == "right") {
          has = true;
          return true;
        }
      });
      return has;
    },
    ObjectsCopy() {
      //排序
      let arr1 = this.objects.filter((ele) => ele["sequence"] === undefined);
      let arr2 = this.objects.filter((ele) => ele["sequence"] !== undefined);
      return arr2
        .sort((a, b) => {
          return Number(a["sequence"]) < Number(b["sequence"]) ? -1 : 1;
        })
        .concat(arr1);
    },
    filteredChips() {
      this.canApply = false;
      this.right_canApply = false;
      let arr = [];
      let data = JSON.parse(JSON.stringify(this.ObjectsCopy)); //深拷贝
      data.map((item, index) => {
        if (typeof item["value"] == "string" && item["value"].trim()) {
          if (item["type"] == "daterange") {
            item["value"] = item["value"]
              .replace(/\-/g, "/")
              .replace(" / ", " - ");
          }
          arr.push(item);
          this.canApply = true;
          // if (item.position === "right") {//只检测右边//2检测 全部
          this.right_canApply = true;
          // }
        }
        if (
          item["value"] &&
          Object.prototype.toString.call(item["value"]).toLowerCase() ===
            "[object array]" &&
          item["value"].length
        ) {
          arr.push(item);
          this.canApply = true;
          // if (item.position === "right") {//只检测右边//2检测 全部
          this.right_canApply = true;
          // }
        }
      });
      return arr;
    },
  },
  data() {
    return {
      canApply: false,
      right_canApply: false,
      isApply: false, //是否提交过
      status: 0, //目前是否筛选状态
      nowShow: false,
      showMore: false,
      curKey: 123,
    };
  },
  methods: {
    onSubmit() {
      this.showMore = false;
      this.$emit("filter");
      this.status = 1;
      this.isApply = true;
    },
    controlNav: function (f) {
      if (!this.nowShow) {
        this.nowShow = true;
      } else {
        this.nowShow = false;
        this.showMore = false;
      }
    },
    reset() {
      // this.$refs["form"].reset();
      // this.curKey = Math.random() * 1000; //侧栏重置
      // this.showMore = false; //侧栏重置
      this.$emit("reset", this.isApply);
      if (this.status) this.status = 0;
      if (this.isApply) {
        this.isApply = false;
        this.showMore = false;
      }
    },
    getSelectedValue: function (obj, value) {
      const that = this;
      if (obj["type"] != "select") return value;
      if (obj["type"] == "select" && obj["selected"]) {
        let key = "";
        if (obj["showKey"]) key = obj["showKey"];
        else key = obj["data"] ? obj["data"]["modelKey"] : "uuid";
        let arr = [];
        obj["selected"].map((item) => {
          arr.push(that.$getCommonLangValue(item[key]));
        });
        if (arr) return arr.join(",");
        else return "";
      }
      return "";
    },

    // 每个类型chip不同长度
    getStyle: function (type) {
      switch (type) {
        case "string":
          return { minWidth: "80px", maxWidth: "150px" };
          break;
        case "select":
          return { minWidth: "100px", maxWidth: "250px" };
          break;
        case "daterange":
          return { minWidth: "200px", maxWidth: "300px" };
          break;
        default:
          break;
      }
    },
  },
};
</script>
